import createDuck from 'lib/ducks/remoteDuck'
import FreeGift from 'lib/api/free-gift'

export default createDuck({
  namespace: 'account',
  store: 'freeGift',
  fetchCallback: (option) => FreeGift.handleOptions(option),
})
